import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import Home from './pages/Home';
import BlogList from './pages/Blog/BlogList';
import BlogPost from './pages/Blog/BlogPost';
import NotFound from './pages/NotFound';
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminLogin from "./pages/Admin/AdminLogin";
import AdminBlogPosts from "./pages/Admin/AdminBlogPosts";
import AdminBlogPost from "./pages/Admin/AdminBlogPost";
import ProtectedRoute from "./components/ProtectedRoute";
import {useAdminAuth} from "./hooks/useAdminAuth";
import {HelmetProvider} from 'react-helmet-async';
import AdminSendMail from "./pages/Admin/AdminSendMail";
import CoursesList from "./pages/Admin/Courses/CoursesList";
import CourseOverview from "./pages/Admin/Courses/CourseOverview";
import CourseContent from "./pages/Admin/Courses/Content/CourseContent";
import CourseSections from "./pages/Admin/Courses/CourseSections";


function AppRoutes() {
    const {isAdmin, loading} = useAdminAuth();
    return (
        <HelmetProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/admin/login" element={<AdminLogin/>}/>
                    <Route
                        path="/admin/dashboard"
                        element={
                            <ProtectedRoute isAdmin={isAdmin} loading={loading}>
                                <AdminDashboard/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/blog/new-post/"
                        element={
                            <ProtectedRoute isAdmin={isAdmin} loading={loading}>
                                <AdminBlogPost/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/mail/"
                        element={
                            <ProtectedRoute isAdmin={isAdmin} loading={loading}>
                                <AdminSendMail/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/blog/"
                        element={
                            <ProtectedRoute isAdmin={isAdmin} loading={loading}>
                                <AdminBlogPosts/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/blog/edit/:id/"
                        element={
                            <ProtectedRoute isAdmin={isAdmin} loading={loading}>
                                <AdminBlogPost/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/course/"
                        element={
                            <ProtectedRoute isAdmin={isAdmin} loading={loading}>
                                <CoursesList/>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/course/:id/overview/"
                        element={
                            <ProtectedRoute isAdmin={isAdmin} loading={loading}>
                                <CourseOverview />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/course/new/overview/"
                        element={
                            <ProtectedRoute isAdmin={isAdmin} loading={loading}>
                                <CourseOverview />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/course/:courseId/content/:contentId/"
                        element={
                            <ProtectedRoute isAdmin={isAdmin} loading={loading}>
                                <CourseContent />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin/course/:courseId/sections/"
                        element={
                            <ProtectedRoute isAdmin={isAdmin} loading={loading}>
                                <CourseSections />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/blog" element={<BlogList/>}/>
                    <Route path="/blog/:slug" element={<BlogPost/>}/>
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Router>
        </HelmetProvider>
    )
}

export default AppRoutes;
